import { connect } from 'react-redux';
import Filters from './Filters';
import {
  classOptions,
  customerOptions,
  destinationOptions,
  fetchCustomerAuthorizations,
  fetchFilterValues,
  isClearButtonDisabled,
  loadingControlOptions,
  productOptions,
  resetFilters,
  setFilter,
  setMobileFilterDrawerOpen,
  terminalOptions,
} from '../store/customerAuthorizationSlice';

const mapState = state => ({
  classOptions: classOptions(state),
  clearButtonDisabled: isClearButtonDisabled(state),
  customerOptions: customerOptions(state),
  destinationOptions: destinationOptions(state),
  fetchingFilterValues: state.loadingManagement.customerAuthorizations.fetchingFilterValues,
  filters: state.loadingManagement.customerAuthorizations.filters,
  loadingControlOptions: loadingControlOptions(state),
  productOptions: productOptions(state),
  terminalOptions: terminalOptions(state),
});

const mapDispatchToProps = {
  fetchCustomerAuthorizations,
  fetchFilterValues,
  resetFilters,
  setFilter,
  setMobileFilterDrawerOpen,
};

export default connect(mapState, mapDispatchToProps)(Filters);
